import * as moment from 'moment';

export class StationManualStartNotificationModel
{
    private _timeStamp: Date;

    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        this._timeStamp = new Date();
    }

    public ControllerId: number;
    public DeviceTypeId: number;
    public IrrigationPin: number;
    public OnOrOff: number;
    public StationNumber: number;
    public TypeCode: number;

    public get TimeStamp(): Date
    {
        return this._timeStamp;
    }

    public _duration: moment.Duration;

    set Duration(value: moment.Duration)
    {
        this._duration = moment.duration(value);
    }

    get Duration(): moment.Duration
    {
        return this._duration;
    }

    private _whenForcedOn: Date;

    set WhenForcedOn(value: Date)
    {
        this._whenForcedOn = new Date(value);
    }

    get WhenForcedOn(): Date
    {
        return this._whenForcedOn;
    }
}
